export interface IHttpState {
  isLoading: boolean;
}

export default {
  isLoading: false,
} as IHttpState;
